<nav class="header-nav navbar navbar-light bg-primary fixed-top"
  [ngClass]="{'multilocation-header': isMultiLocationEnabled && canSwitchLocation}"
  [ngStyle]="{'border-color': isMultiLocationEnabled && canSwitchLocation && user?.shopColor? user?.shopColor : ''}">
  <div class="navbar-brand brand-wrapper align-self-center"
    [ngClass]="{'multilocation-brand': isMultiLocationEnabled && canSwitchLocation, 'al-icon-width': showGlobalSearch}">
    <div class="burger-container" (click)="openNav = !openNav" [ngClass]="openNav ? 'nav-active' : ''">
      <div class="burger">
        <div class="bar topBar"></div>
        <div class="bar btmBar"></div>
      </div>
    </div>

    <a *ngIf="(!isMultiLocationEnabled || !canSwitchLocation) && !corporateId && !isMarkPsDashboard"
      [class.disabled]="isNavigationDisabled" class="pointer position-relative d-block" [routerLink]="brandLogoLink">
      <img src="../../../assets/logo.png" />
    </a>

    <div *ngIf="!isMultiLocationEnabled && !corporateId && isMarkPsDashboard" class="autoleap-icon-wrapper pointer"
      (click)="openLocationSwitchDialog()">

      <div class="autoleap-icon">
        <a class="pointer">
          <img src="assets/img/autoleap-Favicon.svg" alt="AutoLeap" />
        </a>
      </div>

      <div class="dropdown ml-3">
        <a class="btn btn-toggle dropdown-toggle" tooltipPosition="bottom" style="font-weight: 700;
        background-color: var(--white);" [ngStyle]="{'color': user?.shopColor}" [pTooltip]="user?.shopName">
          <i class="fas fa-store-alt"></i> {{user?.shortName}}
        </a>
      </div>
    </div>

    <div *ngIf="isMultiLocationEnabled && canSwitchLocation" class="autoleap-icon-wrapper pointer"
      (click)="openLocationSwitchDialog()">

      <div class="autoleap-icon">
        <a class="pointer" [class.disabled]="isNavigationDisabled">
          <img src="assets/img/autoleap-Favicon.svg" alt="AutoLeap" />
        </a>
      </div>

      <div class="dropdown ml-3">
        <a class="btn btn-toggle dropdown-toggle" tooltipPosition="bottom"
          [ngStyle]="{'color': isMultiLocationEnabled && canSwitchLocation ? user?.shopColor : ''}"
          [pTooltip]="user?.shopName">
          <i class="fas fa-store-alt"></i> {{user?.shortName}}
        </a>
      </div>
    </div>

    <div *ngIf="!isMultiLocationEnabled && corporateId" class="autoleap-icon-wrapper pointer"
      (click)="openCorporateSwitchDialog()">

      <div class="autoleap-icon">
        <a class="pointer">
          <img src="assets/img/autoleap-Favicon.svg" alt="AutoLeap" />
        </a>
      </div>

      <div class="dropdown ml-3">
        <a class="btn btn-toggle bg-white dropdown-toggle" tooltipPosition="bottom">
          Corporate
        </a>
      </div>
    </div>
  </div>

  <div id="navbarSupportedContent" class="collapse navbar-collapse">
    <!-- Start Left Nav -->
    <ul class="navbar-nav mr-auto navbar-left"
      [ngClass]="!isMultiLocationEnabled && (corporateId || isMarkPsDashboard) ? 'ml-30' : ''"
      [ngClass]="openNav ? 'show-nav' : ''">
      <li [id]="'main-nav-' + nav.activeLinkId" *ngFor="let nav of navs" class="nav-item min-width-60 beta"
        [ngClass]="{ 'active active-link': this.activeLinkId === nav.activeLinkId, marketing: nav.name === 'Marketing', trial: marketingAccessType === 'trial' }"
        [routerLinkActive]="['active']">
        <a class="nav-link flex-center-center flex-column" *ngIf="allowedMenuItems[nav.navId]"
          (click)="navigateToALDashboard(nav.url, nav.navId, nav.name)" [class.disabled]="isNavigationDisabled"
          [routerLink]="nav.url">
          <i [class]="nav.icon" [routerLinkActive]="[nav.active]"></i>
          <span class="font-12 text-truncate">{{ nav.name }}</span>
        </a>

        <a class="nav-link flex-center-center flex-column" *ngIf="!allowedMenuItems[nav.navId]"
          (click)="navigate(nav.url, nav.navId, nav.name)">
          <i [class]="nav.icon" [routerLinkActive]="[nav.active]"></i>
          <span class="font-12 text-truncate">{{ nav.name }}</span>
          <span class="lock-item">
            <i class="fas fa-lock"></i>
          </span>
        </a>
      </li>
    </ul>
    <!-- End Left Nav -->

    <div class="ml-auto d-flex">
      <div class="search-global align-self-center responsive-hide"
        *ngIf="!['super', 'onboarder', 'engg', 'sales'].includes(role) && !isNavigationDisabled">
        <app-global-search subId="1"></app-global-search>
      </div>
      <!-- Start Right Nav -->
      <ul class="navbar-nav navbar-right">
        <!-- Start responsive search -->
        <li class="nav-item dropdown flex-center-center flex-column no-border header-dropdown responsive-search">
          <a *ngIf="!showGlobalSearch" class="nav-link" id="search-field" role="button">
            <i class="fas fa-search font-28" (click)="iconClick()"></i>
          </a>
          <!-- [ngClass]="[showGlobalSearch ? 'd-block' : 'd-none']" -->
          <div class="global-search-resp" *ngIf="showGlobalSearch">
            <div class="search-global align-self-center"
              *ngIf="!['super', 'onboarder', 'engg', 'sales'].includes(role)">
              <app-global-search subId="2"></app-global-search>
              <i class="fal fa-times font-18 font-gray-55 close" (click)="closeSearch()"></i>
            </div>
          </div>
        </li>
        <!-- Ends responsive search -->

        <!-- Start Add Menu Dropdown -->
        <li *ngIf="!['super', 'onboarder', 'engg', 'sales'].includes(user.role)"
          class="nav-item dropdown flex-center-center modal-list flex-column min-width-40 no-border header-dropdown">
          <a class="nav-link" id="navbarDropdown" [class.disabled]="isNavigationDisabled"
            *ngIf="allowedMenuItems['addButton']" role="button" data-toggle="dropdown" aria-haspopup="true"
            href="javascript:void(0)">
            <i class="fas fa-plus-circle font-28"></i>
          </a>

          <a class="nav-link" id="navbarDropdown" [class.disabled]="isNavigationDisabled"
            *ngIf="!allowedMenuItems['addButton']" role="button" data-toggle="dropdown" aria-haspopup="true"
            href="javascript:void(0)">
            <i class="fas fa-plus-circle font-28"></i>
            <span class="lock-item right">
              <i class="fas fa-lock"></i>
            </span>
          </a>

          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <span class="dropdown-menu-arrow"></span>

            <div class="ui-g p-0">
              <div class="ui-g-12">
                <!-- Start Menu Items -->
                <div *ngFor="let item of addMenuItems" [ngClass]="item?.title">
                  <div class="ui-g-4 list-items-div" (click)="handleAddItemClick(item.type)">
                    <div class="list-img-div">
                      <i class="{{ item.iconClass }}"></i>
                    </div>

                    <div class="list-text-div ml-2 align-self-center">
                      <p id="add-menu-item-{{ item?.title }}" class="list-item-text custom-heading">
                        {{ item?.title }}
                      </p>
                      <p class="font-10 list-item-text">{{ item?.description }}</p>
                    </div>
                  </div>
                </div>

                <div class="ui-g-12" [ngClass]="serviceLookUpMenu?.title">
                  <div *ngIf="isMotorLookupEnabled" class="ui-g-4 list-items-div" (click)="openServiceLookupDialog()">
                    <div class="list-img-div">
                      <i class="{{ serviceLookUpMenu.iconClass }}"></i>
                    </div>

                    <div class="list-text-div ml-2 align-self-center mb-2">
                      <p id="add-menu-item-{{ serviceLookUpMenu?.title }}" class="list-item-text custom-heading">
                        {{ serviceLookUpMenu?.title }}
                        <i class="title-icon motor-icon">
                          <img [src]="'assets/img/' + serviceLookUpMenu?.icon" alt="{{ serviceLookUpMenu?.title }}">
                        </i>
                      </p>
                      <p class="font-10 list-item-text">{{ serviceLookUpMenu?.description }}</p>
                    </div>
                  </div>

                  <div *ngIf="isMitchellIntegrationEnabled" class="ui-g-4 list-items-div" tooltipPosition="top"
                    [pTooltip]="isMitchell1Connected? 'View Only Repair Information in Mitchell1' : 'Mitchell1 is disconnected'"
                    [ngClass]="{'not-allowed': !isMitchell1Connected}" (click)="handleOpenMitchell1Guide($event)">
                    <div class="list-img-div flex-center-center">
                      <i class="{{ mitchell1RepairGuidesMenu.iconClass }}"></i>
                    </div>

                    <div class="list-text-div ml-2 align-self-center mb-2">
                      <p id="add-menu-item-{{ mitchell1RepairGuidesMenu?.title }}"
                        class="list-item-text custom-heading">
                        {{ mitchell1RepairGuidesMenu?.title }}
                        <i class="title-icon">
                          <img [src]="'assets/img/' + mitchell1RepairGuidesMenu?.icon"
                            alt="{{mitchell1RepairGuidesMenu?.title}}">
                        </i>
                      </p>
                      <p class="font-10 list-item-text">{{ mitchell1RepairGuidesMenu?.description }}</p>
                    </div>
                  </div>

                  <!-- Quick tire look start -->
                  <div *ngIf="isQuickTireLookupEnabled" class="ui-g-4 list-items-div"
                    (click)="getIntegrationSettings()">
                    <div class="list-img-div">
                      <i class="{{ quickTireLookupMenu.iconClass }}"></i>
                    </div>

                    <div class="list-text-div ml-2 align-self-center mb-2">
                      <p id="add-menu-item-{{ quickTireLookupMenu?.title }}" class="list-item-text custom-heading">
                        {{ quickTireLookupMenu?.title }}
                      </p>
                      <p class="font-10 list-item-text">{{ quickTireLookupMenu?.description }}</p>
                    </div>
                  </div>
                  <!-- Quick tire lookup ends -->
                </div>
                <!-- End Menu Items -->
              </div>
            </div>
          </div>
        </li>
        <!-- End Add Menu Dropdown -->

        <li [ngClass]="{ 'active-link active ': activeLinkId === 'settings' }"
          class="nav-item flex-center-center flex-column min-width-40 setting" [routerLinkActive]="['active']"
          (click)="closeLockscreen()">
          <a class="nav-link" *ngIf="allowedMenuItems['settings']" [class.disabled]="isNavigationDisabled"
            [routerLink]="'/settings/company'">
            <i class="fal fa-cog font-28"></i>
          </a>

          <a class="nav-link" *ngIf="!allowedMenuItems['settings']"
            (click)="navigate('/settings/company', 'settings', 'Settings')">
            <i class="fal fa-cog font-28"></i>
            <span class="lock-item right">
              <i class="fas fa-lock"></i>
            </span>
          </a>
        </li>

        <li
          class="nav-item flex-center-center flex-column min-width-40 no-border custom-bell-padding notifications-dropdown"
          [ngClass]="{overlayActive: notifyTrue}">
          <a *ngIf="allowedMenuItems['notifications']" id="notificationsDropDown" class="nav-link" role="button"
            [class.disabled]="isNavigationDisabled" (click)="setNotificationPanelState(true)">
            <i class="fal fa-bell font-28"></i>
            <span *ngIf="notificationsTotalRecord !== 0" class="count-badge">
              {{ notificationsTotalRecord }}
            </span>
          </a>

          <a *ngIf="!allowedMenuItems['notifications']" id="notificationsDropDown" class="nav-link" role="button"
            data-toggle="dropdown" aria-haspopup="true" [class.disabled]="isNavigationDisabled">
            <i class="fal fa-bell font-28"></i>
            <span class="lock-item right">
              <i class="fas fa-lock"></i>
            </span>
            <span *ngIf="notificationsTotalRecord !== 0" class="count-badge">
              {{ notificationsTotalRecord }}
            </span>
          </a>

          <!-- <div class="dropdown-menu" [ngClass]="{show: notifyTrue}">
            <app-notifications-dropdown [notifications]="customerNotifications"
              (scrollingFinished)="onScrollingFinished($event)"
              (fetchNotifications)="fetchNotifications()"></app-notifications-dropdown>
          </div> -->
        </li>

        <li *ngIf="isChatEnabled" [ngClass]="{ 'active-link active ': activeLinkId === 'chat' }"
          class="nav-item flex-center-center flex-column min-width-40 chat" [routerLinkActive]="['active']"
          (click)="closeLockscreen()">
          <a class="nav-link" [class.disabled]="isNavigationDisabled" (click)="navigateToChat()">
            <i class="fal fa-comment-dots font-28"></i>
            <span class="count-badge" *ngIf="openChatCount !== 0">{{ openChatCount }}</span>
          </a>
        </li>

        <li class="nav-item flex-center-center flex-column min-width-40 custom-bell-padding">
          <a class="nav-link" id="intercom-chat" [hidden]="!allowedMenuItems['intercom']" (click)="toggleHighlight()"
            [ngClass]="{ highlight: selected }" href="javascript:void(0)" #intercomBtn>
            <i class="fas fa-question font-28"></i>
          </a>

          <a class="nav-link" id="intercom-chat" [hidden]="allowedMenuItems['intercom']"
            (click)="toggleHighlightLocked()" [ngClass]="{ highlight: selectedLocked }" href="javascript:void(0)"
            #intercomBtn>
            <i class="fas fa-question font-28"></i>
            <span class="lock-item right">
              <i class="fas fa-lock"></i>
            </span>
          </a>
        </li>

        <li class="overflow-hidden max-width-110 nav-item flex-start-center no-border position-relative"
          #profileDropdownContainer>
          <div class="user-profile flex-start-center" style="margin-left: 6px;" (click)="toggleProfileCard()">
            <div class="profile-img flex-center-center mr-2">
              <div *ngIf="!user.image" class="initials flex-center-center text-transform-uppercase">{{ user.initials }}
              </div>

              <img *ngIf="user.image" class="initial" [src]="user.image" />
            </div>

            <div class="profile-img flex-center-start flex-column responsive-hide">
              <span class="font-12 font-bold capitalize max-width-75 truncate">{{ user.firstName }}</span>
              <span *ngIf="user.role !== 'serviceWriter'" class="font-12 capitalize">{{ user.role }}</span>
              <span *ngIf="user.role === 'serviceWriter'" class="font-12 max-width-75 truncate">Service Advisor</span>
            </div>
          </div>

          <div [ngClass]="{ 'd-none': !isProfileCardVisible, 'd-block': isProfileCardVisible }">
            <app-personal-info-card [data]="user" (getUser)="setUserDetails()"
              (toggleCard)="toggleProfileCard()"></app-personal-info-card>
          </div>
        </li>
      </ul>
      <!-- End Right Nav -->
    </div>
  </div>
</nav>

<ngx-loading-bar></ngx-loading-bar>
<app-supplier-sidebar *ngIf="fetchingData"></app-supplier-sidebar>
<app-notifications-sidepanel *ngIf="isNotificationPanelVisible" [isSidebarVisible]="isNotificationPanelVisible"
  (setNotificationPanelState)="setNotificationPanelState(false)" (dismissEvent)="dismissEventCall()"
  (fetchNotifications)="getOpenChatCount()"></app-notifications-sidepanel>
<app-sidebar></app-sidebar>
<app-follow-up-sidepanel *ngIf="fetchingData"></app-follow-up-sidepanel>
<app-tire-storage-sidepanel *ngIf="fetchingData && isTireStorage2Enabled"></app-tire-storage-sidepanel>
<app-custom-toaster *ngIf="isTireStorage2Enabled" (onCloseToaster)="onCloseCustomToaster()" [isShowToaster]="showCustomToaster" [toasterOpts]="customerToasterOptions" (actionClicked)="onTosterAction($event)">
</app-custom-toaster>
<app-qbo-taost></app-qbo-taost>
